import Roles from "@/utils/roles"
import { exigePlanoComunicacao } from "@/utils/plano-comunicacao"

export default [
  {
    path: "/meu-plano-comunicacao",
    name: "meu-plano-comunicacao",
    component: () => import("@/views/area-cliente/plano-comunicacao/index.vue"),
    meta: {
      title: 'Plano de Comunicação',
      authRequired: true,
      roles: [Roles.LerMeuPlanoComunicacao]
    },
    // A role é a mesma para todo cliente, então esconder o item de menu não basta: sem este
    // guard o cliente self-service ainda chegaria na tela digitando a URL.
    beforeEnter: (to, from, next) => {
      if (!exigePlanoComunicacao()) {
        next({ name: 'home' })
        return
      }
      next()
    },
  },
];